export const ROUTES = {
    summary: {
        path: '/',
        name: 'summary',
        displayName: 'My Stance',
    },
    mdr: {
        path: '/mdr',
        name: 'mdr',
        displayName: 'MDR',
        children: {
            incidents: {
                path: '/mdr/incidents',
                name: 'incidents',
                displayName: 'Incidents',
            },
            alerts: {
                path: '/mdr/alerts',
                name: 'alerts',
                displayName: 'Alerts',
            },
            service_requests: {
                path: '/mdr/service-requests',
                name: 'service-requests"',
                displayName: 'Service Requests',
            },
            overview: {
                path: '/mdr/overview',
                name: 'overview',
                displayName: 'Overview',
            },
        },
    },
    external_assets: {
        path: '/external-assets',
        name: 'external_assets',
        displayName: 'External Assets',
        children: {
            domains: {
                path: '/external-assets/domains',
                name: 'external_assets_domains',
                displayName: 'Domains',
            },
            technologies: {
                path: '/external-assets/technologies',
                name: 'external_assets_technologies',
                displayName: 'Technologies',
            },
        },
    },
    users: {
        path: '/users',
        name: 'users',
        displayName: 'Users',
    },
    devices: {
        path: '/devices',
        name: 'devices',
        displayName: 'Devices',
    },
    integrations: {
        path: '/integrations',
        name: 'integrations',
        displayName: 'Integrations',
    },
    fraud_defense: {
        path: '/fraud-defense',
        name: 'fraud_defense',
        displayName: 'Fraud Defense',
        children: {
            open_issues: {
                path: '/fraud-defense/open-issues',
                name: 'fraud_defense_open_issues',
                displayName: 'Issues',
            },
            configurations: {
                path: '/fraud-defense/configurations',
                name: 'fraud_defense_configurations',
                displayName: 'Configurations',
            },
        },
    },
    settings: {
        path: '/settings',
        name: 'settings',
        displayName: 'Settings',
        children: {
            account: {
                path: '/settings/account',
                name: 'settings_account',
                displayName: 'Account',
            },
            user: {
                path: '/settings/user',
                name: 'settings_user',
                displayName: 'User',
            },
            team: {
                path: '/settings/team',
                name: 'settings_team',
                displayName: 'Team',
            },
        },
    },
    auth: {
        path: '/auth',
        name: 'auth',
        displayName: 'Authentication',
        children: {
            login: {
                path: '/login',
                name: 'auth_login',
                displayName: 'Login',
            },
            logout: {
                path: '/logout',
                name: 'auth_logout',
                displayName: 'Log out',
            },
        },
    },
    new_invitation: {
        path: '/new-invitation',
        name: 'new_invitation',
        displayName: 'New Invitation',
    },
} satisfies TRouteMap
